import { useState } from 'react'
import { setSessionCookies } from 'portal-utils/session-cookies'
import { RP_PRIVACY_SETTINGS } from 'portal-modules/common/constants/keys'
import { redirectToHome } from 'portal-modules/common/utils/language-update'

const useCookiesPreferences = ({
  groups,
  updateCookiesNoticeStatus,
  requestCookieBannerClose,
}) => {
  const [groupState, setGroupState] = useState(groups)

  const handleCookiesUpdate = (callback, type) => {
    if (type === 'specific') {
      let newFilterArray = []
      groupState.map(
        ({ group_items, group_id }) =>
          group_items &&
          Object.values(group_items)?.filter(
            item =>
              parseInt(group_id) !== 1 &&
              (typeof item?.checked === 'undefined' || !item?.checked) &&
              newFilterArray.push(item?.group_item_name),
          ),
      )

      let updatedBrowserCookies = (newFilterArray?.length && {
        groups: newFilterArray,
        isCookiesAccepted: true,
      }) || { enabled_all: true, isCookiesAccepted: true }

      setSessionCookies(RP_PRIVACY_SETTINGS, updatedBrowserCookies, true)
    } else {
      let updatedBrowserCookies = {
        enabled_all: type === 'accept_all' ? true : false,
        isCookiesAccepted: true,
      }
      setSessionCookies(RP_PRIVACY_SETTINGS, updatedBrowserCookies, true)
    }
    updateCookiesNoticeStatus(groupState, type)
    typeof callback === 'function' && redirectToHome()
  }

  const handleCookieBannerClose = () => {
    setSessionCookies(
      RP_PRIVACY_SETTINGS,
      { isCookiesAccepted: true },
      true
    )
    requestCookieBannerClose()
  }

  return [
    groupState,
    setGroupState,
    handleCookiesUpdate,
    handleCookieBannerClose,
  ]
}

export default useCookiesPreferences
